import React, { useState } from 'react';
import { Box, IconButton, Snackbar, Typography } from '@mui/material';
import { CheckCircleIcon, CheckIcon, CloseIcon } from './icons';
import {
  successToastCopyBtnSx,
  successToastOuterSx,
  successToastSubtitleSx,
  successToastTitleSx,
  successToastUrlBoxSx,
  successToastUrlTextSx,
} from '../css/revenueItems.styles';

/**
 * Props:
 *   open            — controls visibility
 *   paymentUrl      — URL to display and copy
 *   recipientEmail  — buyer email the invitation was sent to
 *   emailSent       — whether invitation email was sent successfully
 *   onClose         — called when toast should dismiss
 */
const SuccessToast = ({ open, paymentUrl, recipientEmail, emailSent, onClose }) => {
  const [urlCopied, setUrlCopied] = useState(false);

  const handleCopyUrl = () => {
    if (!paymentUrl) return;
    navigator.clipboard.writeText(paymentUrl);
    setUrlCopied(true);
    setTimeout(() => setUrlCopied(false), 2000);
  };

  return (
    <Snackbar
      open={open}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      autoHideDuration={8000}
      sx={{ top: { xs: 16, sm: 24 } }}
    >
      <Box sx={successToastOuterSx}>
        <Box sx={{ width: 6, flexShrink: 0, backgroundColor: '#4caf50' }} />

        <Box sx={{ flex: 1, p: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', mb: 1 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Box sx={{ width: 24, height: 24, flexShrink: 0 }}>
                <CheckCircleIcon />
              </Box>
              <Typography sx={successToastTitleSx}>Create Payment Request successful!</Typography>
            </Box>
            <IconButton size="small" onClick={onClose} sx={{ color: '#8c9198', p: 0, ml: 1, flexShrink: 0 }}>
              <CloseIcon />
            </IconButton>
          </Box>

          <Typography sx={successToastSubtitleSx}>
            {emailSent
              ? `Payment link sent to ${recipientEmail || 'the recipient'}.`
              : `Payment request created. Copy the link below if email delivery failed.`}
          </Typography>

          <Box sx={successToastUrlBoxSx}>
            <Box sx={{ flex: 1, backgroundColor: '#1f2937', px: 1.5, py: 1, overflow: 'hidden' }}>
              <Typography noWrap sx={successToastUrlTextSx}>
                {paymentUrl}
              </Typography>
            </Box>
            <Box onClick={handleCopyUrl} sx={successToastCopyBtnSx}>
              {urlCopied ? (
                <CheckIcon />
              ) : (
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                  <rect x="6" y="1" width="11" height="13" rx="2" stroke="#f3f4f7" strokeWidth="1.5" />
                  <rect x="1" y="4" width="11" height="13" rx="2" fill="#1f2937" stroke="#f3f4f7" strokeWidth="1.5" />
                </svg>
              )}
            </Box>
          </Box>
        </Box>
      </Box>
    </Snackbar>
  );
};

export default SuccessToast;
